export default {
    coordination: 'Coordination of Supports',
    specialist: 'Specialist Support Coordination',
    plan: 'Plan Management',
    tasks: 'Assistance with Daily Tasks (Support Work)',
    therapy: 'Therapy Supports/Behaviour Supports',
    childhood: 'Early Childhood Supports',
    transport: 'Transport/Travel',
    accommodation: 'Accommodation or Respite',
    equipment: 'Equipment',
    home: 'Home Modifications',
    social: 'Community & Social Participation',
    group: 'Group Based activities',
    advocacy: 'Advocacy & Employment/Training Opportunities',
    connector: 'Community Connector',
    eacp: 'Evidence, Access and Coordination of Planning (EACP)',
    nursing: 'Community Nursing ',
};
